import { useRef, useState } from 'react';

import type { ReactNode } from 'react';

export type ConfirmationDialogOptions = {
  content: ReactNode;
  onConfirm: () => void | Promise<void>;
};

export const useConfirmationDialog = () => {
  const onConfirmRef = useRef<() => void | Promise<void>>(() => {});
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState<ReactNode>(null);

  const openConfirm = (options: ConfirmationDialogOptions) => {
    onConfirmRef.current = options.onConfirm;
    setContent(options.content);
    setIsOpen(true);
  };

  const closeConfirm = () => {
    setIsOpen(false);
  };

  const handleConfirm = async () => {
    try {
      await onConfirmRef.current?.();
    } finally {
      closeConfirm();
    }
  };

  return {
    openConfirm,
    closeConfirm,
    isOpen,
    content,
    handleConfirm
  };
};
